import { defineComponent } from 'vue'
import { BlockModule } from '../common'
import { swup } from '@/lib/swup'
import { useFaqContext } from '../faq/composables'

new BlockModule({
    selector: '.block-search-bar-faq',
    vueComponent: defineComponent({
        name: 'block-search-bar-faq',
        props: {
            noTearDown: String,
            searchPageBaseUrl: String,
        },
        setup(props) {
            const { 
                isSearchPage, 
                searchTerm, 
                inputSearchTerm,
                pageNumber
            } = useFaqContext()

            
            const search = () => {  
                searchTerm.value = inputSearchTerm.value.trim()
                pageNumber.value = 1
                
                if (!isSearchPage.value) {
                    swup.navigate(`${props.searchPageBaseUrl}?searchTerm=${encodeURIComponent(searchTerm.value)}&pageNumber=${pageNumber.value}`)
                } else {
                    const url = new URL(window.location.href)
                    url.searchParams.set('searchTerm', searchTerm.value)
                    url.searchParams.set('pageNumber', pageNumber.value.toString())
                    window.history.replaceState(null, '', url.toString())
                }
            }

            return {
                search,
                searchTerm,
                inputSearchTerm
            }
        },
    }),
})
